import { Link } from 'react-router'
import { RiArrowDownLine } from 'react-icons/ri'
import { ROUTES } from '@/constants/routes'

export const HerJourneyHubHeroSection = () => (
  <section className="relative bg-crimson-900 overflow-hidden py-20 lg:py-32">
    {/* Decorative circles */}
    <div
      aria-hidden="true"
      className="absolute top-0 right-0 w-96 h-96 rounded-full bg-crimson-700 opacity-25 -translate-y-1/3 translate-x-1/3 pointer-events-none"
    />
    <div
      aria-hidden="true"
      className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-crimson-700 opacity-20 translate-y-1/3 -translate-x-1/4 pointer-events-none"
    />
    <div
      aria-hidden="true"
      className="absolute top-1/2 left-1/2 w-[600px] h-[600px] rounded-full bg-gold-500 opacity-[0.03] -translate-x-1/2 -translate-y-1/2 pointer-events-none"
    />

    {/* Faint H·E·R watermark */}
    <div
      aria-hidden="true"
      className="absolute right-0 bottom-0 font-display font-bold text-white opacity-[0.03] select-none pointer-events-none leading-none hidden lg:block"
      style={{ fontSize: 'clamp(12rem, 22vw, 22rem)', letterSpacing: '-0.06em', lineHeight: 0.85 }}
    >
      H&#xB7;E&#xB7;R
    </div>

    <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-12">
      <div className="max-w-[720px]">
        {/* Eyebrow */}
        <span
          className="inline-block text-[11px] font-bold uppercase tracking-[0.22em] text-gold-400 mb-6 animate-fade-in"
          style={{ animationDelay: '0.1s' }}
        >
          Free Resources
        </span>

        {/* Heading */}
        <h1
          className="font-display font-bold text-white leading-[1.04] mb-6 animate-fade-in-up"
          style={{ fontSize: 'clamp(2.75rem, 6.5vw, 5rem)', animationDelay: '0.2s' }}
        >
          H.E.R <em className="text-gold-400 not-italic italic">Journey Hub</em>
        </h1>

        {/* Divider */}
        <div
          className="w-14 h-[3px] rounded-full bg-gradient-to-r from-gold-400 to-crimson-500 mb-7 animate-fade-in"
          style={{ animationDelay: '0.3s' }}
        />

        {/* Description */}
        <p
          className="text-base-300 text-[16px] leading-[1.85] max-w-[600px] mb-5 animate-fade-in-up"
          style={{ animationDelay: '0.35s' }}
        >
          Your free pregnancy and postpartum resource library. Each guide has been lovingly created
          by Simone to educate, prepare, and empower you at every stage of your journey — from the
          first trimester through to those precious early days with your newborn.
        </p>
        <p
          className="text-base-400 text-[14.5px] leading-[1.75] max-w-[560px] mb-10 animate-fade-in-up"
          style={{ animationDelay: '0.4s' }}
        >
          Simply click <strong className="text-base-200 font-semibold">Download Guide</strong> on
          any resource below to save it to your device and read at your own pace.
        </p>

        {/* Stats row */}
        <div
          className="flex flex-wrap gap-6 mb-10 animate-fade-in-up"
          style={{ animationDelay: '0.45s' }}
        >
          {[
            { value: '6', label: 'Free Guides' },
            { value: '100%', label: 'Evidence-Based' },
            { value: '∞', label: 'Yours to Keep' },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-3">
              <span className="font-display font-bold text-gold-400 text-2xl leading-none">
                {stat.value}
              </span>
              <span className="text-[12px] text-base-400 uppercase tracking-[0.14em] font-medium">
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div
          className="flex flex-wrap items-center gap-4 animate-fade-in-up"
          style={{ animationDelay: '0.55s' }}
        >
          <a href="#resources" className="btn-primary">
            View All Resources
            <RiArrowDownLine size={17} />
          </a>
          <Link
            to={ROUTES.ENQUIRY}
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-[13.5px] font-semibold text-white border border-white/25 hover:bg-white/10 transition-all duration-200"
          >
            Book a Free Call
          </Link>
        </div>
      </div>
    </div>
  </section>
)
